export const AI_ZIP_PROMPT_TEMPLATE = `The static HTML host rejected my upload because of this unsupported file:
{file_path}

That host is NOT a Node/dev environment. It only accepts a finished static website ZIP.

Create a new downloadable ZIP that I can upload as-is. Follow every rule:

WHAT THE ZIP MUST LOOK LIKE
- index.html at the ZIP root. Not inside dist/, build/, out/, www/, public/, browser/, or any project folder.
- Include only the production build output: finished HTML, CSS, browser JS bundles, images, fonts, and other static assets the pages need.
- Relative URLs only. No leading-slash paths like /assets/..., no <base href="/">. Use ./assets/... and ./about.html so the site works without server rewrite rules.
- Multi-page sites: real .html files for each page (about.html, contact.html, etc.) and <a href="./about.html"> links. Do not rely on History API routes such as /about.
- Keep the current design, copy, and client-side behavior if it can run as static files.

WHAT MUST NOT BE IN THE ZIP
Treat the rejected file as a class of files, not a single path. Also exclude:
- Source: src/, app/, pages/ (framework source), *.ts, *.tsx, *.jsx, *.vue, *.svelte, *.scss (unless already compiled)
- Tooling: node_modules/, .git/, package.json, package-lock.json, yarn.lock, pnpm-lock.yaml, tsconfig*, vite.config.*, webpack.config.*, angular.json, next.config.*, nuxt.config.*, Dockerfile, README*, *.md
- Hosting/server: _redirects, _headers, netlify.toml, vercel.json, firebase.json, .htaccess, nginx.conf, web.config
- Backend: *.php, *.py, *.rb, *.go, *.java, API folders, serverless functions
- Secrets: .env, .env.*, credentials, private keys
- Maps/debug if not required: *.map (omit unless a page actually needs them)

HOW TO BUILD IT
- If this is React/Vue/Angular/Vite/Next/Nuxt: run or reuse the static production build (dist/, build/, out/, or Angular dist/*/browser/). Copy THAT output to the ZIP root. Do not zip the repository.
- If there is no static export (e.g. Next/Nuxt SSR), produce a static export first. If a feature needs a backend, omit it from the ZIP and tell me in chat what must stay hosted elsewhere. Do not put that explanation inside the ZIP.
- Do not invent a new design. Repackage this site.

VALIDATE BEFORE GIVING ME THE DOWNLOAD
Unzip mentally and confirm:
1. Opening the ZIP shows index.html immediately (not a wrapper folder).
2. None of the forbidden names/extensions above exist anywhere in the ZIP.
3. index.html and other HTML files load CSS/JS/images with relative paths.
4. Internal links point to .html files, not SPA routes.
5. ZIP is only the site files — no extra README inside it.

Then give me the downloadable ZIP.`;



// WEBPACK FOOTER //
// ./src/assets/prompts/aiHtmlUploadZip.js